import { GlobalErrorPage } from '@/components/ui/errors'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { maxValue, minValue, number, object, optional, pipe } from 'valibot'

const consentSchema = object({
  step: optional (pipe(number(), minValue(1), maxValue(5)), 1),
})

export const Route = createFileRoute('/consent/')({
  component: Outlet,
  validateSearch: consentSchema,
  errorComponent: GlobalErrorPage,
})
